<template>
  <div>
    <div class="new_internet_bar">
      <div class="officialNewstitle"><router-link :to="'/netbarmanage'"><span><tt>< </tt>返回网吧管理</span></router-link></div>
      <div class="bar_title">温馨提示：一经发现非区域网吧串号，立马删除网吧</div>
      <!-- <div class="bar_information">
        <span>*</span>我的区域选择
      </div> -->

      <!-- <div class="my_region">
        <div class="my_region_box" @click="jump()" v-if="adderArr == ''">
          <span style="color:red;padding-right:20px">暂无代理区域</span>
          <el-button class="addrressBtnss" type="primary" plain>立即申请</el-button>
        </div>

        <div class="each_txt_box" v-if="adderArr != ''">
          <div class="each_txt" >
            <el-input
              v-model="each_txt"
              placeholder="请输入要查询的区域"
              class="el_input_style"
              style="width:400px"
            ></el-input>
            <a class="search" @click.stop="choiceAddressType(adderArr)" :href="'#'+each_txt">
              <img src="../../assets/images-img/echar.png" alt />
            </a>
          </div>
        </div>

        <div
          v-if="adderArr != ''"
          class="my_region_box"
          @click="choiceAddress(item,index)"
          v-for="(item,index) in adderArr"
          :key="index"
        >
          <div
            :class="addressState == index?'addrressBtn':'Bat'"
            type="primary"
            plain
            :id="item.split('-')[1]"
          >{{item.split("-")[1]}}</div>
        </div>
      </div> -->
      <div class="bar_from">
        <div class="bar_frist">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <!-- <div class="grid-content bg-purple">
                <div class="account_settings">账号设置</div>
                <el-input
                  v-model="newBar.accountSettings"
                  clearable
                  placeholder="账号为4-20位数字或字母，不能包含空格下划线等待特殊符号和标点"
                ></el-input>
              </div>-->
            </el-col>
          </el-row>
        </div>

        <!-- <div class="bar_frist">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_settings">密码设置</div>
                <el-input v-model="newBar.passwordSettings" placeholder="密码为6-20位" clearable></el-input>
              </div>
            </el-col>
          </el-row>
        </div>-->

        <div class="bar_frist">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_settings">网吧名称</div>
                <el-input v-model="newBar.cy_bar_name" placeholder="请输入4-20位网吧名称" maxlength="20" clearable></el-input>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="bar_frist">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_settings">终端数量</div>
                <el-input
                  v-model="newBar.bar_count"
                  placeholder="请输入终端数量"
                  clearable
                  oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- <div class="bar_frist">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_settings">代理电话</div>
                <el-input v-model="newBar.agentPhone" placeholder="请输入11位手机号" clearable></el-input>
              </div>
            </el-col>
          </el-row>
        </div>-->

        <div class="bar_frist">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_settings">详细地址</div>
                <el-input v-model="newBar.bar_remark" placeholder="请输入详细地址" clearable></el-input>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="bar_type">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="title">网吧类型</div>
                <el-radio v-model="bar_type" :label="1">动态网吧</el-radio>
                <el-radio v-model="bar_type" :label="0">静态网吧</el-radio>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="bar_right_add" v-if="bar_type == 0">
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_set">
                  网吧IP1
                  <span>*至少绑定一个网吧的ip地址，否则无法使用，多网卡请将ip全部绑定（上限5个ip）</span>
                </div>
                <el-input v-model="ipAress.barIp1" placeholder="请输入合法IP" clearable></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_set">网吧IP2</div>
                <el-input v-model="ipAress.barIp2" placeholder="请输入合法IP" clearable></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_set">网吧IP3</div>
                <el-input v-model="ipAress.barIp3" placeholder="请输入合法IP" clearable></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_set">网吧IP4</div>
                <el-input v-model="ipAress.barIp4" placeholder="请输入合法IP" clearable></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="300" style="margin:0">
            <el-col :span="16" style="padding:0">
              <div class="grid-content bg-purple">
                <div class="account_set">网吧IP5</div>
                <el-input v-model="ipAress.barIp5" placeholder="请输入合法IP" clearable></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div style="clear:both"></div>

      <el-row class="confirm">
        <el-button type="primary" @click="newConfirm()">确认</el-button>
        <el-button type="primary" plain style="margin-left:50px" @click="resetBar()">重置</el-button>
      </el-row>
    </div>
  </div>
</template>
<script>
import {ipcheck} from "../../common/utils"
export default {
  data() {
    return {
      each_txt: "",
      ipAress: {
        barIp1: "", //网吧IP1
        barIp2: "", //网吧IP2
        barIp3: "", //网吧IP3
        barIp4: "", //网吧IP4
        barIp5: "" //网吧IP5
      },
      newBar: {
        // accountSettings: "", //账号设置
        // passwordSettings: "", //密码设置
        cy_bar_name: "", //代理名字
        // agentPhone: "", //手机号码
        bar_remark: "", //详细地址
        // county: "", //选择区域
        bar_count: 20, // 终端数量
        ip_list: "", //id地址  用字符串的方式传过去
        net_bar_id: "" //通过后端接口获取ID
      },
      addressState: null,
      bar_type: 1
    };
  },
  created() {
    this.getNetBarId();
  },
  computed: {
    adderArr() {
      let getArea = localStorage.district;
      let splictArr = getArea.split(",");
      return splictArr;
    },
    closure() {
      return function(data) {
        let addrs = [];
        if (data != "") {
          for (const addr of data.split(",")) {
            let name = addr.split("-");
            addrs.push(name[1]);
          }
        }
        return addrs.join(" ");
      };
    }
  },
  methods: {
    // 获取net_bar_id
    getNetBarId() {
      // // 为给定 ID 的 user 创建请求
      this.$http.post(this.$api.api.get_barId, {}).then(res => {
        console.log(res.data.barId);
        if (res.data.code != 1) {
          return this.$message.error(res.data.msg);
        }
        this.newBar.net_bar_id = res.data.barId;
      });
    },
    // // 选择地址方法
    // choiceAddress(val, index) {
    //   this.addressState = index;
    //   this.newBar.county = val;
    // },
    // // 选择地址方法
    // choiceAddressType(val) {
    //   for (let i = 0; i < val.length; i++) {
    //     if (this.each_txt != "") {
    //       if (this.each_txt == this.closure(val[i])) {
    //         this.addressState = i;
    //         this.newBar.county = val[i];
    //         return;
    //       }
    //     } else {
    //       return this.$message.error("请输入搜索区域");
    //     }
    //   }
    //   return this.$message.error("搜索区域不存在");
    // },
    // jump() {
    //   setTimeout(() => {
    //     this.$store.commit("activePath", "/applicationArea");
    //     this.$router.push({
    //       path: "/applicationArea"
    //     });
    //     this.$router.go(0);
    //   });
    // },
    // 确定
    newConfirm() {
      if (this.fromData()) {
        // let { barIp1, barIp2, barIp3 } = { ...this.ipAress };
        // this.newBar.ip_list = `${barIp1},${barIp2},${barIp3}`;
        this.newBar.ip_list = Object.values(this.ipAress).filter(ele => !!ele).join(",")

        this.newBar.bar_count = Number(this.newBar.bar_count);
        
        this.$http.post(this.$api.api.add_bar, this.newBar).then(res => {
          console.log(res);
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          }
          this.resetBar();
          this.getNetBarId();
          this.$router.push("/netbarmanage");
          return this.$message.success(res.data.result);
        });
       
      }
    },
    // 判断from的数据是否合格
    fromData() {
      // if (this.newBar.county == "") {ipcheck
      //   this.$message.error("请选择区域");

      //   return false;
      // }

      if (this.newBar.cy_bar_name.trim() == "") {
        this.$message.error("网吧名称不能为空");
        return false;
      }
      if (this.newBar.cy_bar_name.trim().length<4) {
        this.$message.error("网吧名称不能少于4位");
        return false;
      }
      if (this.newBar.bar_count == "") {
        this.$message.error("请输入终端数量");
        return false;
      }
      if (this.newBar.bar_count < 10) {
        this.$message.error("终端数量必须大于10");
        return false;
      }

      if (this.newBar.bar_remark.trim() == "") {
        this.$message.error("详细地址不能为空");
        return false;
      }
      if (this.newBar.bar_remark.trim() == "") {
        this.$message.error("详细地址不能为空");
        return false;
      }
      if(this.bar_type == 0) {
        if (this.ipAress.barIp1.trim() == "") {
          this.$message.error("网吧IP1必填");
          return false;
        }
        if (this.ipAress.barIp1.trim() != ""&&!ipcheck(this.ipAress.barIp1)) {
          this.$message.error("请输入正确的ip1地址");
          return false;
        }
        if(this.ipAress.barIp2.trim() != ""&&!ipcheck(this.ipAress.barIp2)){
          this.$message.error("请输入正确的ip2地址");
          return false;
        }
        if(this.ipAress.barIp3.trim() != ""&&!ipcheck(this.ipAress.barIp3)){
          this.$message.error("请输入正确的ip3地址");
          return false;
        }
        if(this.ipAress.barIp4.trim() != ""&&!ipcheck(this.ipAress.barIp4)){
          this.$message.error("请输入正确的ip4地址");
          return false;
        }
        if(this.ipAress.barIp5.trim() != ""&&!ipcheck(this.ipAress.barIp5)){
          this.$message.error("请输入正确的ip5地址");
          return false;
        }
      }
      return true;
    },

    // 重置
    resetBar() {
      for (const key in this.ipAress) {
        this.ipAress[key] = "";
      }
      for (let key in this.newBar) {
        this.newBar[key] = "";
      }
      this.getNetBarId();
      this.newBar.bar_count = 20;
      this.newBar.ip_list= "192.168.2.1";
      this.addressState = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.officialNewstitle{
    margin: 16px 0;
    text-align: left;
    font-size: 16px;
    color: #6692ff;
    tt{
      font-family: "SimSun" !important;
      font-weight: 600;
    }
  }
  .officialNewstitle a:hover{
    color: #759dff;
  }
   .officialNewstitle a:active{
    color: #537fed;
  }
.span1 {
  text-align: center;
  width: 1000px;
  font-size: 12px;
  // background: red;
  // display: inline-block;
  //  padding-left: 300px;
}
.new_internet_bar {
  // padding: 30px 50px 40px 140px;
  // margin: 20px 20px 0px 20px;
  // border: 10px solid #f1f6f9;
  position: relative;
  padding-left: 100px;
  .bar_title {
    font-size: 16px;
    font-weight: bold;
    color: #ec0808;
  }
  .bar_information {
    padding-top: 30px;
    padding-bottom: 20px;
    color: #727272;
    font-size: 14px;
    font-weight: bold;
    span {
      color: #ec0808;
    }
  }
  .my_region {
    display: flex;
    flex-wrap: wrap;
    .my_region_box {
      margin-right: 20px;
      margin-top: 20px;
    }
  }
  .bar_from {
    margin-top: 11px;
    width: 50%;
    float: left;
    .bar_frist {
      .account_settings {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        padding-top: 10px;
        padding-bottom: 10px;
      }
      .bar_from_con {
        display: flex;
      }
    }
  }
  .bar_type {
    margin-top: 11px;
    width: 50%;
    .title {
      font-size: 14px;
        font-weight: bold;
        color: #333;
        padding-top: 10px;
        padding-bottom: 10px;
    }
  }
  .bar_right_add {
    padding-top: 10px;
    float: left;
    width: 50%;
    position: relative;
    .add {
      position: absolute;
      top: 53px;
      right: 35%;
    }
    .account_set {
      font-size: 14px;
      font-weight: bold;
      color: #727272;
      padding-bottom: 10px;
      padding-top: 10px;
      width: 800px;
      span {
        color: red;
        font-size: 12px;
      }
    }
  }
  .confirm {
    margin-top: 40px;
    margin-bottom: 20px;
  }
}
.addrressBtnss {
  color: #fff;
  background: #409eff;
}
.addrressBtn {
  color: #fff;
  background: #409eff;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}
.addrressBtn:hover {
  background: #66b1ff;
  cursor: pointer;
}

.Bat {
  border: 1px solid #409eff;

  height: 30px;
  color: #409eff;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  width: 60px;
}
.Bat:hover {
  background: #ecf5ff;
}
.each_txt_box {
  position: absolute;
  top: 40px;
  left: 230px;
  .each_txt {
    position: relative;
    .search_txt {
      // padding: 0 10px 0 0px;
    }
    .search {
      position: absolute;
      top: 9px;
      right: 8px;
      width: 53px;
      height: 24px;
      background: #409eff;
      text-align: center;
      justify-content: center;
      align-items: center;
      display: flex;
      border-radius: 6px;
      cursor: pointer;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
